import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zh from './lang/zh'
import en from './lang/en'

Vue.use(VueI18n)


const i18n = new VueI18n({
  locale: 'en',  // 👉 默认语言，改成 en-US 就是英文
  fallbackLocale: 'zh', // 找不到翻译时，回退到中文
  messages: {
    zh,
    en
  }
})

export default i18n
